<template>
  <div class="product-service-month-select">
    <div
      :class="active == item.value ? 'active' : ''"
      v-for="item in monthArray"
      :key="item.value"
      @click="onClick(item.value)"
    >{{item.label}}</div>
  </div>
</template>

<script>
export default {
  name: "ProductServiceMonthSelect",
  props: ["active"],
  data() {
    return {
      monthArray: [
        {
          label: "1月",
          value: 1
        },
        {
          label: "2月",
          value: 2
        },
        {
          label: "3月",
          value: 3
        },
        {
          label: "4月",
          value: 4
        },
        {
          label: "5月",
          value: 5
        },
        {
          label: "6月",
          value: 6
        },
        {
          label: "7月",
          value: 7
        },
        {
          label: "8月",
          value: 8
        },
        {
          label: "9月",
          value: 9
        },
        {
          label: "10月",
          value: 10
        },
        {
          label: "11月",
          value: 11
        },
        {
          label: "12月",
          value: 12
        }
      ]
    };
  },
  methods: {
    onClick(e) {
      this.$emit("change", e);
    }
  }
};
</script>

<style lang="less" scoped>
.product-service-month-select {
  width: 100%;

  padding: 20px 0;

  div {
    display: inline-block;
    width: 60px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    margin-right: 10px;
    background: rgba(245, 245, 245, 1);
    border: 1px solid rgba(245, 245, 245, 1);
    border-radius: 3px;

    cursor: pointer;
  }

  div.active {
    font-weight: bold;
    background: rgba(234, 255, 243, 1);
    color: rgba(27, 153, 79, 1);
    border: 1px solid rgba(27, 153, 79, 1);
  }
}
</style>

